import { create } from "zustand";
import { persist } from "zustand/middleware";

const ACK_TTL_MS = 3000;

function appendAcknowledgedConversation(set, convId) {
  set((s) => ({
    recentlyAcknowledgedConversationIds: s.recentlyAcknowledgedConversationIds.includes(convId)
      ? s.recentlyAcknowledgedConversationIds
      : [...s.recentlyAcknowledgedConversationIds, convId],
  }));
}

function removeAcknowledgedConversation(set, convId) {
  set((s) => ({
    recentlyAcknowledgedConversationIds: s.recentlyAcknowledgedConversationIds.filter((cid) => cid !== convId),
  }));
}

function scheduleAckExpiry(set, convId) {
  appendAcknowledgedConversation(set, convId);
  setTimeout(() => removeAcknowledgedConversation(set, convId), ACK_TTL_MS);
}

export const useMentionsStore = create(
  persist(
    (set, get) => ({
      mentions: [],
      recentlyAcknowledgedConversationIds: [],
      addMention: (m) => set((s) => ({
        mentions: [...s.mentions, { id: `mention-${Date.now()}`, acknowledged: false, ...m }],
      })),
      acknowledgeMention: (id) => {
        const m = get().mentions.find((x) => x.id === id);
        set((s) => ({
          mentions: s.mentions.map((x) => (x.id === id ? { ...x, acknowledged: true } : x)),
        }));
        if (m?.conversationId) {
          scheduleAckExpiry(set, m.conversationId);
        }
      },
      getUnreadForMember: (memberId) => get().mentions.filter((m) => m.mentionedMemberId === memberId && !m.acknowledged),
      getUnreadForConversation: (conversationId, memberId) => get().mentions.filter(
        (m) => m.conversationId === conversationId && m.mentionedMemberId === memberId && !m.acknowledged,
      ),
    }),
    {
      name: "sellix.mentions.v1",
      partialize: (state) => ({ mentions: state.mentions }),
    },
  ),
);
